import { useEffect, useState } from 'react'

import { env } from '@/config/env'

export type LocationOption = { elId: number; value: string; regionId: number | null }

/**
 * Legacy `useLocations`: one fetch on mount, "City, Country" labels sorted, placeholders dropped
 * (the server already drops them). A failed load yields an empty list and the picker hides —
 * the search still works without a location, exactly as it did while the endpoint was absent.
 */
export function useLocations() {
  const [locations, setLocations] = useState<LocationOption[]>([])

  useEffect(() => {
    const controller = new AbortController()
    fetch(`${env.apiUrl}/public/locations`, { signal: controller.signal })
      .then(async (response) => (response.ok ? ((await response.json()) as LocationOption[]) : []))
      .then((list) => setLocations(Array.isArray(list) ? list : []))
      .catch(() => setLocations([]))
    return () => controller.abort()
  }, [])

  return locations
}
